module.exports = __webpack_public_path__ + "img/img-scholarshipprogram2@2x.1de78202.jpg";